<template>
  <div style="height: 730px;width:860px;">
    <img v-if="files" :src="files" style="height: 430px;width: 100%" >
    <!--<div id="ditu" style="width: 100%;height:300px"></div>-->
    <el-amap v-if="showMap" vid="ditu" :zoom="18" :center="center" class="amap-demo" :style="{height:files?'270px':'720px'}" >
      <el-amap-marker vid="adress" :position="center" ></el-amap-marker>
      <el-amap-text v-for="text in texts" :text="text.text" :offset="text.offset" :position="text.position" :events="text.events" :visible="text.visible"></el-amap-text>
    </el-amap>
  </div>
</template>

<script>
  export default {
    props:{
      files:String,
      location:{
        type:Object,
        default: () => {}
      }
    },
    components: {
    },
    data () {
      return {
        texts: [
          {
            position: [116.6651700000,39.9057500000],
            text: '我在 中仓街道办事处 附近',
            offset: [0, -50],
            visible:true,
            events: {
              click: () => {
                alert('click text');
              }
            }
          }
        ],
        center:[116.6651700000,39.9057500000],
        showMap:false
      }
    },
    watch:{
      location (newValue,oldValue) {
        this.center = [newValue.x,newValue.y]
        this.texts[0].text = '我在 '+newValue.name+' 这'
        this.texts[0].position = [newValue.x,newValue.y]
        this.showMap = true
      }
    },
    mounted () {
    }
  }
</script>

<style scoped>
.amap-demo{
  /*height: 270px;*/
  width: 100%;
  margin-top:40px
}
</style>
